import React from 'react';

import styled from 'styled-components';

import EditBatchShopRequestsModalDate from './EditBatchShopRequestsModalDate';
import EditBatchShopRequestsModalStatus from './EditBatchShopRequestsModalStatus';
import EditBatchShopRequestsModalUserSelect from './EditBatchShopRequestsModalUserSelect';

const Container = styled.div`
  display: flex;
  flex-flow: column;
  width: 540px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const EditBatchShopRequestsModelContent = () => {
  return (
    <Container>
      <EditBatchShopRequestsModalStatus />
      <EditBatchShopRequestsModalUserSelect fieldKey="shopper_id" Label="Shopper" />
      <EditBatchShopRequestsModalUserSelect fieldKey="auditor_id" Label="Auditor" />
      <EditBatchShopRequestsModalDate />
    </Container>
  );
};

export default EditBatchShopRequestsModelContent;
